// Shared per-design lifetime counter (config/designCounters) — the number in
// every computed pancake title: "Saturnina (#6)", "Freestyle (#7)",
// "Untitled #45". Key is a designId, "freestyle", or "untitled" (customs the
// guest chose not to title). Atomic transaction; non-fatal on failure — the
// order still submits, it just won't carry a sequence number until the
// Maintenance backfill repairs it.
import { db } from "../firebase";
import { doc, runTransaction } from "firebase/firestore";

export async function assignDesignSequence(key) {
  try {
    const counterRef = doc(db, "config", "designCounters");
    return await runTransaction(db, async (tx) => {
      const snap = await tx.get(counterRef);
      const data = snap.exists() ? snap.data() : {};
      const next = (data[key] || 0) + 1;
      tx.set(counterRef, { [key]: next }, { merge: true });
      return next;
    });
  } catch (err) {
    console.warn("[GTS] designSequence assign failed:", err);
    return null;
  }
}
